var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      attrs: { href: "#" },
      on: {
        click: [
          function ($event) {
            $event.preventDefault()
          },
          _vm.tippytap,
        ],
      },
    },
    [
      _vm._v(
        "\n\t" +
          _vm._s(
            _vm.$wait.is("impersonateUser")
              ? "Assuming identity..."
              : "Assume Identity"
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }